import {useEffect, useRef, useState} from "react";
import {useDataContext} from "../../../context/DataContext";
import {KSYB_INDIVIDUAL_URL, SERVICE_ENDPOINTS} from "../../../config/config";
import {fetchTranslations} from "../../../utils/helper";
import selectOptionsTranslations from '../../../mock/lang/selectOptionsTranslations.json'
import selectOptionsEnglish from '../../../mock/lang/selectOptionsEnglish.json'
import axios from 'axios';
import {useSearchParams} from "react-router-dom";
import locales from "../../../assets/const/locales";

export default function useSelectOptions () {
    const [mobileValue ,setMobileValue] = useState(1);
    const [antivirusValue ,setAntivirusValue] = useState(1);
    const [microsoftValue ,setMicrosoftValue] = useState(1);
    const [fixedValue, setFixedValue] = useState(1);
    const [business , setBusiness] = useState(false);
    const [marketing , setMarketing] = useState(false);
    const {data} = useDataContext();
    const [taxId,setTaxId] = useState(null);
    const [agree, setAgree] = useState(false);
    const [powerApps , setPowerApps] = useState([]);
    const [flavor , setFlavor] = useState(null);
    const [button , setButton] = useState(false);
    const [phoneNumber , setPhoneNumber] = useState(null);
    const [temp, setTemp] = useState([]);
    const [storeCode , setStoreCode] = useState(null);
    // const [translations, setTranslations] = useState(null);
    const [thanks, setThanks] = useState(false);
    const [message , setMessage] = useState('');
    const [errorFaq , setErrorFaq] = useState(false);
    const [errorCards , setErrorCards] = useState(false);
    const [show, setShow] = useState(true);
    const [cards, setCards] = useState(null);
    const [faqsData , setFaqsData] = useState([]);
    const [searchParams] = useSearchParams();
    const [buttonClicked, setButtonClicked] = useState(false);

    const lang = (searchParams.get("lang")?.toLowerCase() === locales.ENGLISH) ? locales.ENGLISH : locales.GREEK;
    const translations = lang === "en" ? selectOptionsEnglish : selectOptionsTranslations;

    const store = (searchParams.get("store") !== null);

    const url = SERVICE_ENDPOINTS.KSYB_INDIVIDUAL_URL.replace("{lang}",lang);
    const divRef = useRef(null);

    const scrollToDiv = () => {
        if (divRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };


    // useEffect(()=> {
    //     // setTranslations();
    //     // fetchTranslations(selectOptionsTranslations, lang
    //     // ).then(setTranslations
    //     // ).catch(() => setTranslations({}));
    //
    // },[lang])



    useEffect(()=> {
        setTaxId(data?.taxId);
        getFaqs();
        getCards();
        // fetchTranslations(selectOptionsTranslations, lang
        // ).then(setTranslations
        // ).catch(() => setTranslations({}));

        },[])

    const handleChange=(type, value) => {
        setTemp(powerApps);
        switch (type){
            case "mobile" :
                setMobileValue(value);
                break;
            case "antivirus" :
                setAntivirusValue(value);
                break;
            case "microsoft" :
                setMicrosoftValue(value);
                break;
            case "fixed":
                setFixedValue(value);
                break;
            case "business":
                setBusiness(!business);
                break;
            case "marketing":
                setMarketing(!marketing);

                break;
            case "agree":
                setAgree(!agree);
                break;
            case "powerApps":
                const index = powerApps.findIndex( p => p === value);
                if(index !== -1) {
                    temp.splice(index,1);
                    setPowerApps(temp);
                } else {
                    powerApps.push(value);
                }
                break;
            case"flavor":
                setFlavor(value);
                break;
            case "phoneNumber":
                setPhoneNumber(value);
                break;
            case "storeCode":
                setStoreCode(value);
                break;
        }
    }
    useEffect(()=>{
        if(phoneNumber !==null  && phoneNumber.length===10 && store && storeCode?.length >0 && buttonClicked === false ){
            setButton(true);
        } else if(phoneNumber !==null  && phoneNumber.length===10 && !store && buttonClicked === false){
            setButton(true);
        } else {
            setButton(false);
        }
        },[phoneNumber,storeCode,buttonClicked]);

    const getCall = () => {
        // setThanks(true);
        // handleCode('400');

        window.fbq &&  fbq('track', '[b2b_callback]');

        setButtonClicked(true);
        return  axios.post(SERVICE_ENDPOINTS.KSYB_OPTIONS,{
            taxId:taxId,
            contactNumber : phoneNumber,
            preferences: {
                mobileAssets: mobileValue,
                fixedAssets: fixedValue,
                secureAntivirus: antivirusValue,
                microsoft365: microsoftValue,
                powerApps: powerApps,
                yourBusinessOnline: business,
                cosmoteDM4U:marketing,
                shopId: storeCode
            },
        }).then((res)=> {
            setMessage(translations['successMessage']);
            setThanks(true);
            setTimeout(() => {
                scrollToDiv();
            }, 10);
        }).catch(()=> {
            setMessage(translations['failMessage']);
            setThanks(true);
            setTimeout(() => {
                scrollToDiv();
            }, 10);
        })
    }

        const getFaqs = () => {
            axios.get(SERVICE_ENDPOINTS.KSYB_GET_FAQS.replace('{lang}', lang))
                .then((res) => {

                    setFaqsData(res?.data?.data[0]);
                    window.parent.dispatchEvent(new CustomEvent('resizeIframeKsyb', {
                    }));
                }).catch(() => {
                setErrorFaq(true);
            })
        }

        const getCards = () => {
            axios.get(SERVICE_ENDPOINTS.KSYB_GET_CARDS.replace('{lang}', lang))
                .then((res) => {
                    setCards(res?.data?.data);
                }).catch(() => {
                setErrorCards(true);
            })
        }

        const getBack = () => {
            window.location.href="/hub/business/kickStartYourBusiness.jsp";
        }


        return {
            handleChange,
            mobileValue,
            fixedValue,
            taxId,
            antivirusValue,
            microsoftValue,
            getCall,
            button,
            phoneNumber,
            translations,
            storeCode,
            faqsData,
            show,
            cards,
            thanks,
            message,
            store,
            url,
            getBack, divRef
        };
    }
